import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import { adminApi } from '../../lib/adminApi';

const emptyForm = {
  title: '', url: '', group_name: 'Main', description: '', icon: '', sort_order: 0, status: 'published', open_in_new_tab: false,
};

export default function AdminNavigationForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!id) return;
    adminApi(`/api/admin/navigation-items/${id}`)
      .then((item) => setForm({
        title: item.title || '', url: item.url || '', group_name: item.group_name || 'Main',
        description: item.description || '', icon: item.icon || '', sort_order: item.sort_order || 0,
        status: item.status || 'published', open_in_new_tab: Boolean(item.open_in_new_tab),
      }))
      .catch((err) => setError(err.message));
  }, [id]);

  function update(e) {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

  async function submit(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await adminApi(id ? `/api/admin/navigation-items/${id}` : '/api/admin/navigation-items', {
        method: id ? 'PUT' : 'POST',
        body: JSON.stringify(form),
      });
      navigate('/adxm/navigation');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminLayout title={id ? 'Edit Menu Item' : 'Add Menu Item'} subtitle="Create grouped links for the global public mega menu.">
      <form onSubmit={submit} className="mx-auto max-w-4xl space-y-5 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        {error && <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700">{error}</div>}
        <div className="grid gap-4 md:grid-cols-2">
          <label className="block text-sm font-bold text-slate-700">Title<input name="title" value={form.title} onChange={update} className="mt-1 w-full rounded-xl border border-slate-200 p-3" required /></label>
          <label className="block text-sm font-bold text-slate-700">URL<input name="url" value={form.url} onChange={update} placeholder="/admissions or https://..." className="mt-1 w-full rounded-xl border border-slate-200 p-3" required /></label>
          <label className="block text-sm font-bold text-slate-700">Group<input name="group_name" value={form.group_name} onChange={update} className="mt-1 w-full rounded-xl border border-slate-200 p-3" /></label>
          <label className="block text-sm font-bold text-slate-700">Icon / Emoji<input name="icon" value={form.icon} onChange={update} className="mt-1 w-full rounded-xl border border-slate-200 p-3" /></label>
          <label className="block text-sm font-bold text-slate-700">Sort Order<input type="number" name="sort_order" value={form.sort_order} onChange={update} className="mt-1 w-full rounded-xl border border-slate-200 p-3" /></label>
          <label className="block text-sm font-bold text-slate-700">Status<select name="status" value={form.status} onChange={update} className="mt-1 w-full rounded-xl border border-slate-200 p-3"><option value="published">Published</option><option value="draft">Draft</option><option value="archived">Archived</option></select></label>
        </div>
        <label className="block text-sm font-bold text-slate-700">Description<textarea name="description" value={form.description} onChange={update} rows="4" className="mt-1 w-full rounded-xl border border-slate-200 p-3" /></label>
        <label className="flex items-center gap-3 text-sm font-bold text-slate-700"><input type="checkbox" name="open_in_new_tab" checked={form.open_in_new_tab} onChange={update} /> Open in new tab</label>
        <button className="rounded-xl bg-emerald-700 px-6 py-3 font-black text-white hover:bg-emerald-800" disabled={saving}>{saving ? 'Saving...' : 'Save Menu Item'}</button>
      </form>
    </AdminLayout>
  );
}
